module.exports = __webpack_public_path__ + "images/a2f360530131f770a6ed23c4f26cec3761a4e653aee7924abbd6fe84874b0aed.svg";